module.exports = __webpack_public_path__ + "img/report.40e4fab.png";